import React from 'react';
import { canReadPhotos, canReadRecipes, hasSiteAccess } from './rbacUtils';

/**
 * Home hub after Google sign-in: recipes, photos, and shared family areas when RBAC allows.
 */
export default function LandingPage({
  claims,
  userEmail,
  onOpenPhotos,
  onOpenRecipes,
  onOpenForum,
  onOpenContacts,
  onOpenCalendar,
}) {
  const showPhotos = canReadPhotos(claims);
  const showRecipes = canReadRecipes(claims);
  const showHubExtras = hasSiteAccess(claims);

  return (
    <div className="landing-page">
      <div className="landing-inner landing-inner--wide">
        <p className="landing-welcome">
          Signed in as <strong>{userEmail}</strong>
        </p>
        <h1 className="landing-title">Whitson Family</h1>
        <p className="landing-sub">Choose an area below.</p>

        <div className="landing-cards">
          {showRecipes && (
            <button type="button" className="landing-card" onClick={onOpenRecipes}>
              <span className="landing-card-icon" aria-hidden>
                🍳
              </span>
              <span className="landing-card-title">Family Recipes</span>
              <span className="landing-card-desc">View and edit directions, ingredients, and measurements.</span>
            </button>
          )}
          {showPhotos && (
            <button type="button" className="landing-card landing-card--secondary" onClick={onOpenPhotos}>
              <span className="landing-card-icon" aria-hidden>
                🖼
              </span>
              <span className="landing-card-title">Photo / Video Gallery</span>
              <span className="landing-card-desc">Browse, tag, and upload family photos.</span>
            </button>
          )}
          {showHubExtras && (
            <button type="button" className="landing-card landing-card--forum" onClick={onOpenForum}>
              <span className="landing-card-icon" aria-hidden>
                💬
              </span>
              <span className="landing-card-title">Forum</span>
              <span className="landing-card-desc">Family discussions and announcements.</span>
            </button>
          )}
          {showHubExtras && (
            <button type="button" className="landing-card landing-card--contacts" onClick={onOpenContacts}>
              <span className="landing-card-icon" aria-hidden>
                📇
              </span>
              <span className="landing-card-title">Contacts</span>
              <span className="landing-card-desc">Reach family members and important numbers.</span>
            </button>
          )}
          {showHubExtras && (
            <button type="button" className="landing-card landing-card--calendar" onClick={onOpenCalendar}>
              <span className="landing-card-icon" aria-hidden>
                📅
              </span>
              <span className="landing-card-title">Calendar</span>
              <span className="landing-card-desc">Shared dates, gatherings, and reminders.</span>
            </button>
          )}
        </div>

        {!showRecipes && !showPhotos && !showHubExtras && (
          <p className="landing-none">No applications are assigned to your account yet.</p>
        )}
      </div>
    </div>
  );
}
